// Module
var code = `<template>
  <require from="../../elements/statuses/autoImportStatus/autoImportStatus"></require>
  <require from="../../agElements/iconButtons/manualPriceLink/manualPriceLink"></require>
  <require from="../../agElements/iconButtons/portfolioLink"></require>
  <require from="./reporting-overview.scss"></require>
  <require from="../grid-filter/grid-filter"></require>
  <div class="reporting-overview">
    <grid-filter class="reporting-overview__toolbar" grid.bind="grid" state-key.bind="stateKey" excel-export-params.bind="contextMenu.exportToExcel">
      <span mdc-headline5>Overview</span>
      <portfolio-selector if.bind="customerService.selectedCustomer.usePortfolio" label="Portfolio" value.bind="portfolio"></portfolio-selector>
    </grid-filter>
    <div class="reporting-overview__grid-container">
      <ag-grid-aurelia if.bind="!error" theme-selector grid-options.bind="gridOptions" style.bind="gridStyle" aggregated-fields-changed.trigger="saveAggregatedFields()" grid-columns-changed.trigger="saveGridState()" view-model.ref="grid">
        <ag-grid-column cell-class="" header-name="" field="uuid" width.bind="70" pinned="left">
          <ag-cell-template>
            <portfolio-link css.bind="test"></portfolio-link>
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column cell-class="text-center" header-name="" field="uuid" editable="false" width.bind="70" pinned="left">
          <ag-cell-template>
            <manual-price-link></manual-price-link>
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="#" field="instrumentId" type="number" pinned="left" editable="false" width.bind="70">
        </ag-grid-column>

        <ag-grid-column header-name="Name" field="reportName" pinned="left" editable="false" min-width.bind="150" sort="asc"></ag-grid-column>

        <ag-grid-column header-name="ISIN/OrgNr" field="isin" editable="false" width.bind="150" hide-col.bind="true">
          <ag-cell-template>
            \${params.data.isin ? params.data.isin : params.data.orgNr}
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="Currency" field="currencyCode" editable="false" width.bind="90"></ag-grid-column>

        <ag-grid-column header-name="Country" field="countryCode" editable="false" width.bind="90" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Portfolio" field="portfolio" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Ticker" field="ticker" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Tax" field="taxable" width.bind="80" editable="false" filter="agSetColumnFilter" value-formatter.bind="boolValueFormatter">
          <ag-cell-template>
            <check-icon bool-value.bind="params.value"></check-icon>
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="Lo" field="longTerm" hide-col.bind="true" width.bind="80" editable="false" filter="agSetColumnFilter" value-formatter.bind="boolValueFormatter">
          <ag-cell-template>
            <check-icon bool-value.bind="params.value"></check-icon>
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="LCM" field="lowerOfCostOrMarket" hide-col.bind="true" width.bind="80" editable="false" filter="agSetColumnFilter" value-formatter.bind="boolValueFormatter">
          <ag-cell-template>
            <check-icon bool-value.bind="params.value"></check-icon>
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="auto" field="autoPriceStatus" width.bind="80">
          <ag-cell-template>
            <auto-import-status></auto-import-status>
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="Type" field="securitiesTypeId" editable="false" width.bind="100" editable="false" value-formatter.bind="typeValueFormatter" filter="agSetColumnFilter" filter-params.bind="{valueFormatter: typeValueFormatter}">
        </ag-grid-column>

        <ag-grid-column header-name="Price" field="sellPrice" type="amount" width.bind="130" editable="false">
        </ag-grid-column>

        <ag-grid-column header-name="Price Ccy" field="sellPriceCcy" editable="false" width.bind="90" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="P.Source" field="sellPriceType" width.bind="60" editable="false" tooltip-value-getter.bind="priceTypeTooltip"></ag-grid-column>

        <ag-grid-column header-name="Loan Qty" field="instrumentLoanQuantity" type="amountTwoDec" width.bind="130" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Unit Costprice" field="unitCostPrice" type="rightAligned" width.bind="130" editable="false" hide-col.bind="true">
          <ag-cell-template>
            \${params.data.unitCostPrice | numericFormatter:'fourDec'}
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="Unit Costprice (AVG)" field="avgUnitCostPrice" type="rightAligned" width.bind="130" editable="false" hide-col.bind="true" if.bind="useAverageCostPrice">
          <ag-cell-template>
            \${params.data.unitCostPrice | numericFormatter:'fourDec'}
          </ag-cell-template>
        </ag-grid-column>

        <ag-grid-column header-name="Quantity" field="quantity" type="amountFourDec" editable="false" width.bind="130"></ag-grid-column>

        <ag-grid-column header-name="CostPrice" field="totalCostPrice" type="amountTwoDec" agg-func="sum" width.bind="130" editable="false"></ag-grid-column>

        <ag-grid-column header-name="CostPrice (AVG)" field="avgCostPrice" type="amountTwoDec" agg-func="sum" width.bind="130" editable="false" hide-col.bind="true" if.bind="useAverageCostPrice"></ag-grid-column>

        <ag-grid-column header-name="Estimated Value" field="estimatedValue" type="amountTwoDec" agg-func="sum" editable="false" width.bind="140"></ag-grid-column>

        <ag-grid-column header-name="Unrealized" field="unrealized" type="amountTwoDec" agg-func="sum" editable="false" width.bind="130"></ag-grid-column>

        <ag-grid-column header-name="Unrealized (AVG)" field="avgUnrealized" type="amountTwoDec" agg-func="sum" editable="false" width.bind="130" hide-col.bind="true" if.bind="useAverageCostPrice"></ag-grid-column>

        <ag-grid-column header-name="Profit/Loss" col-id="periodProfitLoss" value-getter.bind="periodProfitLossValueGetter" type="amountTwoDec" agg-func="sum" width.bind="130" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Dividend" col-id="periodDividend" value-getter.bind="periodDividendValueGetter" type="amountTwoDec" agg-func="sum" width.bind="130" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Interest" col-id="periodInterest" value-getter.bind="periodInterestValueGetter" type="amountTwoDec" agg-func="sum" width.bind="130" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Last Imp Date" field="lastImportedPriceDate" type="date" width.bind="130" editable="false"></ag-grid-column>

        <ag-grid-column header-name="Last Price Update Success Date" field="lastPriceUpdateSuccess" type="date" width.bind="130" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Last Curr Date" field="lastImportedCurrencyDate" type="date" width.bind="130" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Last Curr Rate" field="lastImportedCurrencyRate" type="amountTwoDec" width.bind="130" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Exchange name" col-id="exchangeName" value-getter.bind="exchangeNameValueGetter" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Market" col-id="market" value-getter.bind="marketValueGetter" width.bind="90" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="DebugSellprice" field="mathSellPrice" type="amount" hide-col.bind="true" editable="false"></ag-grid-column>

        <ag-grid-column header-name="LastImportedPrice" field="lastImportedPrice" type="amount" hide-col.bind="true" editable="false"></ag-grid-column>

        <ag-grid-column header-name="ManualPrice" field="manualPrice" type="amount" hide-col.bind="true" editable="false"></ag-grid-column>

        <ag-grid-column header-name="LastManualPrice" field="lastManualPrice" type="amount" hide-col.bind="true" editable="false"></ag-grid-column>

        <ag-grid-column header-name="Last Manual Price Date" field="lastManualPriceDate" type="date" width.bind="130" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Accounting Value" field="accountingValue" type="amountTwoDec" agg-func="sum" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Accounting Value (AVG)" field="avgAccountingValue" type="amountTwoDec" agg-func="sum" editable="false" hide-col.bind="true" if.bind="useAverageCostPrice"></ag-grid-column>

        <ag-grid-column header-name="Unreal. Acc. Value" field="unrealizedAccountingValue" type="amountTwoDec" agg-func="sum" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Unreal. Acc. Value (AVG)" field="avgUnrealizedAccountingValue" type="amountTwoDec" agg-func="sum" editable="false" hide-col.bind="true" if.bind="useAverageCostPrice"></ag-grid-column>

        <ag-grid-column header-name="Tax Value" field="taxValue" type="amountTwoDec" agg-func="sum" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column header-name="Last Tax Value Date" field="lastTaxValueDate" type="date" width.bind="130" editable="false" hide-col.bind="true"></ag-grid-column>

        <ag-grid-column repeat.for="c of categoryColumns" col-id.bind="c.colId" header-name.bind="c.header" value-getter.bind="c.valueGetter" hide-col.bind="true"></ag-grid-column>

        <ag-loading-overlay-template>
          <mdc-circular-progress></mdc-circular-progress>
        </ag-loading-overlay-template>

      </ag-grid-aurelia>
    </div>

    <message if.bind="error" icon="error" colour="mdc-theme--error" class="reporting-overview__error">\${error.message}
    </message>
  </div>
</template>
`;
// Exports
export default code;